{
  "title": "Today",
  "subscription_required": "Active subscription required to start this exercise.",
  "weekly_exercise_section": "Weekly exercise",
  "collapse_daily_tip": "Hide daily tip",
  "show_daily_tip": "Show daily tip",
  "daily_warmup_title_pending": "It’s time for your daily warm up!",
  "daily_warmup_title_completed": "Daily warm ups",
  "daily_warmup_error_title": "Warm up unavailable",
  "daily_warmup_error_message": "We couldn’t load your warm up progress. Try again, or continue with your other exercises.",
  "measurement_reminder_title": "Start voice assessment",
  "measurement_reminder_duration": "How long will it take? - {{duration}}",
  "measurement_reminder_error_title": "Voice assessment unavailable",
  "measurement_reminder_error_message": "We couldn’t load your voice assessment. Try again, or continue with your other exercises.",
  "weekly_exercises_error_title": "Weekly exercise unavailable",
  "weekly_exercises_error_message": "We couldn’t load your weekly exercises. Try again, or contact support if the problem persists.",
  "weekly_exercises_empty_title": "No exercises this week",
  "weekly_exercises_empty_message": "There are no scheduled exercises for this week. Try selecting another week.",
  "minutes_short": "min",
  "week_picker_go_to_today": "Today",
  "week_n": "Week {{week}}",
  "weekly_widget_exercises_label": "Exercises",
  "weekly_widget_exercise_goal_label": "Exercise goal",
  "weekly_widget_streak_label": "Streak",
  "weekly_widget_exercises_value_completed": "{{count}} completed",
  "weekly_widget_exercise_goal_value_one": "{{count}} exercise",
  "weekly_widget_exercise_goal_value_other": "{{count}} exercises",
  "weekly_widget_streak_value_one": "{{count}} week",
  "weekly_widget_streak_value_other": "{{count}} weeks",
  "weekly_widget_error_title": "Weekly progress unavailable",
  "weekly_widget_error_message": "We couldn’t load your weekly progress. Try again, or continue with today’s exercises."
}
